import { render, staticRenderFns } from "./SupportOrderHistoryVueComponent.vue?vue&type=template&id=124001b2&"
import script from "./SupportOrderHistoryVueComponent.vue?vue&type=script&lang=ts&"
export * from "./SupportOrderHistoryVueComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SupportOrderHistoryVueComponent.vue?vue&type=style&index=0&id=124001b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports